import { GhostButtonNeutral } from 'rwl-ui';
import { EmailSVG } from '../../../themes/icons';
import { HideOnMDScreen } from '../HideOnMDScreen';
import { useEnqueueEngagement } from '../../../hooks';
import { ConversionType } from 'rwl-shared/dist/models/plugin/Conversion';

type ShareEmailProps = {
    email?: string;
    mediaId?: string;
    workSiteId?: string;
};

export const ShareEmail = ({ email }: ShareEmailProps): JSX.Element | null => {
    const { enqueue } = useEnqueueEngagement();

    if (!email) {
        return null;
    }

    return (
        <GhostButtonNeutral
            href={`mailto:${email}`}
            className={'shareEmail'}
            onClick={() => {
                enqueue({
                    type: 'Conversion',
                    conversionType: ConversionType.Email,
                    target: 'Share Email CTA',
                    clickedAt: new Date(),
                    pageUrl: window.location.href,
                });
            }}
        >
            <EmailSVG />
            <HideOnMDScreen>{email}</HideOnMDScreen>
        </GhostButtonNeutral>
    );
};
